import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Row, Select } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "../../../../../../../store/root.js";
import { getPathInfo } from "../../../../../../../util/template/form.js";
import { getFormPropsByLanguage, getSelectPropsByLanguage, getTranslationFlagElementStyle, getTranslationFlagNamePath, hasTranslationFlagsChanged, onTranslationValueChange } from "../../../../../../../util/translation.js";
import { LanguageIcon } from "../language-icon-addon/language-icon.js";
const TranslationSelectFormFieldEntry = observer(({ lang, flexPathConfig, customPlaceholder, formProps, selectProps })=>{
    const form = Form.useFormInstance();
    const { rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const inputInfo = getPathInfo(flexPathConfig, lang);
    const { style } = getFormPropsByLanguage(lang, translationSettings);
    return /*#__PURE__*/ _jsx(Form.Item, {
        shouldUpdate: (prev, next)=>hasTranslationFlagsChanged(prev, next, getTranslationFlagNamePath(inputInfo.flagNamePath)),
        noStyle: true,
        children: ()=>{
            const translationFlagElementStyle = getTranslationFlagElementStyle(form, inputInfo.flagNamePath);
            const selectPropsByLanguage = getSelectPropsByLanguage(lang, translationSettings);
            const dynamicSelectProps = {
                ...selectProps,
                ...selectPropsByLanguage,
                style: {
                    ...translationFlagElementStyle,
                    ...selectProps?.style,
                    ...selectPropsByLanguage?.style
                },
                onChange: ()=>{
                    onTranslationValueChange(form, inputInfo.flagNamePath, lang);
                }
            };
            return /*#__PURE__*/ _jsxs(Row, {
                gutter: [
                    10,
                    10
                ],
                style: {
                    ...style,
                    flexFlow: "row"
                },
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        flex: "1",
                        children: /*#__PURE__*/ _jsx(Form.Item, {
                            name: inputInfo.namePath,
                            hasFeedback: true,
                            noStyle: true,
                            ...formProps,
                            children: /*#__PURE__*/ _jsx(Select, {
                                placeholder: selectProps?.placeholder || customPlaceholder?.(lang),
                                ...dynamicSelectProps
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        flex: "0",
                        children: /*#__PURE__*/ _jsx(LanguageIcon, {
                            lang: lang,
                            flexPathConfig: flexPathConfig
                        })
                    })
                ]
            }, inputInfo.key);
        }
    });
});
export { TranslationSelectFormFieldEntry };
